import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NgHttpService } from '../auth/httpservice';
import { environment } from '@/app/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PerfilService {
    constructor(private http: HttpClient, private _http: NgHttpService) { }

    listarPorId(id: string): Observable<any> {
        return this._http.get(environment.apiGeral, `Perfil/ListarPorId/${id}`, {});
    }

    listar(body: any = { ativo: 0 }): Observable<any> {
        return this._http.get(environment.apiGeral, `Perfil/listar`, body)
    }

    alterar(user: any): Observable<any> {
        return this._http.put(environment.apiGeral, `Perfil/Alterar`, user)
    }

    add(data: any): Observable<any> {
        data.tipo = 1
        return this._http.post(environment.apiGeral, `Perfil/Adicionar`, data)
    }

    excluir(id: string): Observable<any> {
        return this._http.put(environment.apiGeral, `Perfil/Excluir/${id}`, {});
    }
}
